import SpriteSymbol from "../../../node_modules/_svg-baker-runtime@1.4.7@svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/_svg-sprite-loader@6.0.11@svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-delete",
  "use": "icon-delete-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\" id=\"icon-delete\">\n  <path d=\"M8.00005 8.91929L11.076 11.9952L11.9952 11.076L8.91929 8.00005L11.9952 4.92415L11.076 4.00491L8.00005 7.08081L4.92412 4.00488L4.00488 4.92412L7.08081 8.00005L4.00488 11.076L4.92412 11.9952L8.00005 8.91929Z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol